module.exports = __webpack_public_path__ + "static/media/4ODA3.f9b1f8fa.jpg";